import { Injectable } from '@angular/core';
import { CusHttp } from '../../core/services/CusHttp';
import { URLSearchParams } from "@angular/http";
// 学生资料修改前获取 学生信息设置 根据学生id获取个人资料接口
const GETSTUDENTBASEDATA = 'v1/student/profile';
// 学生资料设置接口修改后从新设置学生个人信息
const POSTSTUDENTBASEDATA = 'v1/student/set-profile';
// 用户修改密码
const POSTPASSWORD = 'v1/users/updpwd';
//、、用户账号绑定信息 用户账号绑定信息 v1/users/is-bind?uid=2
const USERBINGINFO_URL = 'v1/users/is-bind';
//绑定邮箱/手机发送验证码 v1/users/send-code
const USERBINDCODE_URL = 'v1/users/send-code';
//用户绑定邮箱/手机号-验证验证码接口 v1/users/check-code
const USERBINDDATA_URL = 'v1/users/check-code';
//解除用户绑定信息 v1/users/relieve-bind?uid=1&type=3
const USERRELIEVEBINDE_URL = 'v1/users/relieve-bind';
@Injectable()
export class EditStudentService {

  constructor(
    public _http: CusHttp,

  ) { }



  // 学生资料修改前获取 学生信息设置 根据学生id获取个人资料接口
  getStudentBaseData(did: string) {
    let URL = GETSTUDENTBASEDATA + `?id=${did}`;
    return this._http.get(URL);
  };
  // 学生资料设置接口修改后从新设置学生个人信息
  postStudentBaseData(obj: any) {
    let params = new FormData();
    for (let option in obj) {
      params.append(option, obj[option]);
    }
    return this._http.post(POSTSTUDENTBASEDATA, params);
  }
  // 用户修改密码
  postPassWordData(obj: any) {
    let params = new FormData();
    for (let option in obj) {
      params.append(option, obj[option]);
    }
    return this._http.post(POSTPASSWORD, params);
  }
  //用户账号绑定信息 用户账号绑定信息
  getStudentBindData() {
    let URL = USERBINGINFO_URL;
    return this._http.get(URL);
  };
  //绑定邮箱/手机发送验证码 v1/users/send-code
  postUserBingCode(str: string) {
    let params = new FormData();
    params.append('account', str);
    return this._http.post(USERBINDCODE_URL, params);
  }
  //用户绑定邮箱/手机号-验证验证码接口 v1/users/check-code
  postUserBindData(obj: any) {
    let params = new FormData();
    for (let option in obj) {
      params.append(option, obj[option]);
    }
    return this._http.post(USERBINDDATA_URL, params);
  }
  //解除用户绑定信息 v1/users/relieve-bind?uid=1&type=3
  getUserRelieveBind(did: any, type: any) {
    let URL = USERRELIEVEBINDE_URL + `?id=${did}&type=${type}`;
    return this._http.get(URL);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/edit-student.service.ts